module.exports = __webpack_public_path__ + "static/SFMono-Semibold-8282ed99a84b8e9c803baf3df5b76c01.ttf";